import { CTA_ACTION_TYPES } from '../../../constants/actionTypes/dashboardActionTypes';

export const INITIAL_STATE = '';

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case CTA_ACTION_TYPES.SET_CTA_TYPE:
            return action.ctaType;
        case CTA_ACTION_TYPES.CLEAR_DASHBOARD_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};